module.exports = __webpack_public_path__ + "img/infoVino.20a2cf76.jpg";